import { z } from 'zod';

import { PostfixOperandSchema } from './operand';

export const PostfixCriteriaSchema = z.object({
  postfixExpression: z.array(z.string()),
  operands: z.array(PostfixOperandSchema),
});

export type PostfixCriteria = z.infer<typeof PostfixCriteriaSchema>;
